import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { bp } from 'features/dashboard/tokens'

const STORAGE_KEY = 'bp_dashboard_passports_banner_dismissed'

const seen = () => {
  try { return window.localStorage.getItem(STORAGE_KEY) === '1' } catch { return false }
}
const markSeen = () => {
  try { window.localStorage.setItem(STORAGE_KEY, '1') } catch { /* private mode */ }
}

const PassportsBanner = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(() => !seen())
  if (!open) return null

  const go = () => { markSeen(); navigate('/portfolios?level=bp') }
  const dismiss = () => { markSeen(); setOpen(false) }

  return (
    <Banner role='note'>
      <IconTile><ApartmentRoundedIcon style={{ fontSize: 24 }} /></IconTile>
      <Text>
        <Title>Looking for your buildings?</Title>
        <Sub>Your Building Passports now live on the Portfolios page. Open the full list any time.</Sub>
      </Text>
      <GoBtn type='button' onClick={go}>
        Go to my Passports <ArrowForwardRoundedIcon style={{ fontSize: 18 }} />
      </GoBtn>
      <Close type='button' aria-label='Dismiss' onClick={dismiss}>
        <CloseRoundedIcon style={{ fontSize: 18 }} />
      </Close>
    </Banner>
  )
}

export default PassportsBanner

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 20px;
  margin-bottom: 18px;
  border-radius: 14px;
  background: ${({ theme }) => theme.colors.secondary};
  box-shadow: 0 4px 16px rgba(12, 18, 41, 0.10);

  @media (max-width: ${bp.mobile}) {
    flex-wrap: wrap;
    gap: 10px;
    padding: 14px;
    row-gap: 12px;
  }
`

const IconTile = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;

  @media (max-width: ${bp.mobile}) {
    order: 1;
    width: 38px;
    height: 38px;
  }
`

const Text = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: ${bp.mobile}) {
    order: 2;
    flex: 1 1 100%;
  }
`

const Title = styled.div`
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.2px;
  color: #fff;
  margin-bottom: 2px;
`

const Sub = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
`

const GoBtn = styled.button`
  font: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 10px 18px;
  border: none;
  border-radius: 999px;
  background: #fff;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: filter 160ms ease;
  white-space: nowrap;
  &:hover { filter: brightness(0.96); }

  @media (max-width: ${bp.mobile}) {
    order: 3;
    flex: 1 1 100%;
    justify-content: center;
    padding: 11px 16px;
  }
`

const Close = styled.button`
  font: inherit;
  cursor: pointer;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  transition: background-color 160ms ease;
  &:hover { background: rgba(255, 255, 255, 0.18); color: #fff; }

  @media (max-width: ${bp.mobile}) {
    order: 1;
    margin-left: auto;
  }
`
